(() => {
  const initializeHeaderSearch = (form) => {
    if (form.dataset.tiHeaderSearchReady === 'true') return;

    const category = form.querySelector('[data-ti-header-search-category]');
    const categoryControl = form.querySelector('[data-ti-header-search-category-control]');
    const categoryButton = form.querySelector('[data-ti-header-search-category-button]');
    const categoryLabel = form.querySelector('[data-ti-header-search-category-label]');
    const categoryMenu = form.querySelector('[data-ti-header-search-category-menu]');
    const categoryOptions = Array.from(form.querySelectorAll('[data-ti-header-search-category-option]'));
    const input = form.querySelector('input[name="q"]');
    if (
      !category ||
      !categoryControl ||
      !categoryButton ||
      !categoryLabel ||
      !categoryMenu ||
      !categoryOptions.length ||
      !input
    )
      return;

    const selectedOptionIndex = () =>
      Math.max(
        0,
        categoryOptions.findIndex((option) => option.dataset.value === category.value),
      );

    const closeCategoryMenu = ({ returnFocus = false } = {}) => {
      categoryMenu.hidden = true;
      categoryButton.setAttribute('aria-expanded', 'false');
      if (returnFocus) categoryButton.focus();
    };

    const openCategoryMenu = ({ focus = 'selected' } = {}) => {
      categoryMenu.hidden = false;
      categoryButton.setAttribute('aria-expanded', 'true');

      const selectedIndex = selectedOptionIndex();
      const targetIndex = focus === 'first' ? 0 : focus === 'last' ? categoryOptions.length - 1 : selectedIndex;
      categoryOptions[targetIndex]?.focus();
    };

    const selectCategory = (option) => {
      category.value = option.dataset.value || '';
      categoryLabel.textContent = option.textContent.trim();
      categoryOptions.forEach((item) => item.setAttribute('aria-selected', String(item === option)));
      category.dispatchEvent(new Event('change', { bubbles: true }));
      closeCategoryMenu({ returnFocus: true });
    };

    const moveOptionFocus = (currentOption, direction) => {
      const currentIndex = categoryOptions.indexOf(currentOption);
      const nextIndex = Math.min(categoryOptions.length - 1, Math.max(0, currentIndex + direction));
      categoryOptions[nextIndex]?.focus();
    };

    if (!category.value && input.value.trim()) {
      const matchingOption = Array.from(category.options).find(
        (option) => option.value && input.value.trim().startsWith(option.value),
      );
      if (matchingOption) {
        category.value = matchingOption.value;
        input.value = input.value.trim().slice(matchingOption.value.length).trim();
      }
    }

    const currentOption = categoryOptions[selectedOptionIndex()];
    if (currentOption) {
      categoryLabel.textContent = currentOption.textContent.trim();
      categoryOptions.forEach((option) => option.setAttribute('aria-selected', String(option === currentOption)));
    }

    categoryButton.addEventListener('click', () => {
      if (categoryMenu.hidden) openCategoryMenu();
      else closeCategoryMenu();
    });

    categoryButton.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openCategoryMenu({ focus: event.key === 'ArrowDown' ? 'first' : 'last' });
      }
    });

    categoryOptions.forEach((option) => {
      option.addEventListener('click', () => selectCategory(option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          moveOptionFocus(option, event.key === 'ArrowDown' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          categoryOptions[event.key === 'Home' ? 0 : categoryOptions.length - 1]?.focus();
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeCategoryMenu({ returnFocus: true });
        } else if (event.key === 'Tab') {
          closeCategoryMenu();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!categoryControl.contains(event.target)) closeCategoryMenu();
    });

    form.dataset.tiHeaderSearchReady = 'true';
    form.addEventListener('submit', (event) => {
      const categoryQuery = category.value.trim();
      const textQuery = input.value.trim();

      if (!categoryQuery && !textQuery) {
        event.preventDefault();
        window.location.assign(form.dataset.allProductsUrl || '/collections/all');
        return;
      }

      input.value = [categoryQuery, textQuery].filter(Boolean).join(' ');
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-ti-header-search-form]').forEach(initializeHeaderSearch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
